import { pathJoin } from 'src/reducers/routing/utils'

export const createHaulerDetailViewRoutesMap = (prefix: string) => ({
  configuration: pathJoin(prefix)('configuration').chain,
  pricing: pathJoin(prefix)('pricing').chain,
  compensation: pathJoin(prefix)('compensation').chain,
  'settlement-report': pathJoin(prefix)('settlement-report').chain,
  credits: pathJoin(prefix)('credits').chain,
  'invoice-reconciliation': pathJoin(prefix)('invoice-reconciliation').chain,
  users: pathJoin(prefix)('users').chain,
  vehicles: pathJoin(prefix)('vehicles').chain,
  locations: pathJoin(prefix)('locations').chain,
  areas: pathJoin(prefix)('areas').chain,
})
